import Vue from 'vue';

let key = 'tenant';

const env = process.env.VUE_APP_NODE_ENV;
if (env === 'development') {
  key = 'hrsata-tenant';
}

export default new Vue({
  data() {
    return {
      key: key,
      innerTenant: localStorage.getItem(key),
    }
  },
  watch: {
    innerTenant(to) {
      if (to == null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, to);
      }
    },
  },
  computed: {
    tenant() {
      return this.innerTenant;
    },
  },
  created() {
  },
  methods: {
    setTenant(tenant) {
      this.innerTenant = tenant;
    },
    clear() {
      this.innerTenant = null;
    }
  },
})
